import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 24px 24px 48px;
  box-sizing: border-box;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 1100px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const HeaderTitle = styled.h1`
  margin: 0;
  font-size: 28px;
  line-height: 1.2;
  color: #212121;
`;

export const HeaderSubtitle = styled.p`
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
  color: #616161;
`;

export const PostsGrid = styled.div`
  column-count: 1;
  column-gap: 24px;

  > * {
    break-inside: avoid;
    margin-bottom: 24px;
    display: inline-block;
    width: 100%;
  }

  @media (min-width: 900px) {
    column-count: 2;
  }
`;

export const SupportBox = styled.div`
  background: #fff3ef;
  border: 1px solid #ffd5c9;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SupportContent = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const SupportLogo = styled.img`
  width: 170px;
  max-width: 100%;
  border-radius: 10px;
  background: #ffffff;
  padding: 6px;
  border: 1px solid #f0f0f0;
`;

export const SupportDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 200px;
  flex: 1;
`;

export const SupportLabel = styled.span`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #b91c1c;
`;

export const SupportValue = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: #212121;
`;

export const DonationHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
`;

export const DonationBadge = styled.span`
  background: #ffeadf;
  color: #b91c1c;
  border: 1px solid #fecaca;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 6px 10px;
  border-radius: 999px;
`;

export const DonationActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const CopyButton = styled.button`
  background: #ed4e2a;
  color: #fff;
  border: none;
  padding: 10px 16px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(237, 78, 42, 0.3);
  transition: transform 160ms ease, box-shadow 160ms ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 8px 20px rgba(237, 78, 42, 0.35);
  }
`;

export const PixKey = styled.p`
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: #424242;
  word-break: break-word;
`;

export const PixImage = styled.img`
  width: 190px;
  max-width: 100%;
  align-self: center;
`;

export const IconContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
